import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { useModal } from '@/hooks/useModal'
import { useToast } from '@/hooks/useToast'
import { api } from '@/services/api'
import { handleSetMoods } from '@/storage/modules/moods/reducer'
import { MoodResponseProps } from '@/types/moodsProps'

import { Button } from '../Button'
import { Input } from '../form/Input'

interface FormMoodProps {
  isExist?: MoodResponseProps
}

export function FormMood({ isExist }: FormMoodProps) {
  const { register, handleSubmit, setValue } = useForm<MoodResponseProps>()

  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()
  const { showToast } = useToast()
  const { closeModal } = useModal()

  const refreshMoods = async () => {
    const response = await api
      .get('/moods')
      .then((res) => res.data.data as MoodResponseProps[])

    dispatch(handleSetMoods({ moods: response }))
  }

  const onSubmit = async (data: MoodResponseProps) => {
    try {
      setIsLoading(true)

      if (isExist) {
        await api.patch(`/moods/${isExist.id}`, data)

        showToast('Mood edited successfully', {
          type: 'success',
          theme: 'light',
        })
      } else {
        await api.post('/moods', data)

        showToast('Mood added successfully', {
          type: 'success',
          theme: 'light',
        })
      }

      await refreshMoods()
      closeModal()
    } catch (err: unknown) {
      const errMessage =
        err instanceof Error ? err.message : 'Error saving mood'
      const apiMessage =
        typeof err === 'object' &&
        err !== null &&
        'response' in err &&
        typeof err.response === 'object' &&
        err.response !== null &&
        'data' in err.response &&
        typeof err.response.data === 'object' &&
        err.response.data !== null &&
        'message' in err.response.data &&
        typeof err.response.data.message === 'string'
          ? err.response.data.message
          : errMessage

      showToast(`${apiMessage}`, {
        type: 'error',
        theme: 'light',
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isExist) {
      setValue('title', isExist.title)
    }
  }, [isExist, setValue])

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <Input
          placeholder="Digit mood title"
          label="Mood"
          name="title"
          register={register}
          required
        />

        <Button
          title={isExist ? 'Edit' : 'Save'}
          variant="purple"
          isLoading={isLoading}
        />
      </form>
    </div>
  )
}
